import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/dashboard/block-scan-page'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '',
        needLogin: false
      },
      component: require('@/components/Login').default
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '',
        needLogin: false
      },
      component: require('@/components/Register').default
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        title: '',
        needLogin: true
      },
      component: require('@/components/Dashboard').default,
      children: [
        {
          path: 'users-page',
          name: 'users-page',
          meta: {
            title: 'Users',
            needLogin: true
          },
          component: require('@/components/UsersPage').default
        },
        {
          path: 'user-review-page',
          name: 'user-review-page',
          meta: {
            title: 'User Review',
            needLogin: true
          },
          component: require('@/components/UserReviewPage').default
        },
        {
          path: 'user-detail-page/:name',
          name: 'user-detail-page',
          meta: {
            title: 'Users',
            needLogin: true
          },
          component: require('@/components/UserDetailPage').default
        },
        {
          path: 'summary-page',
          name: 'summary-page',
          meta: {
            title: 'Dashboard',
            needLogin: true
          },
          component: require('@/components/SummaryPage').default
        },
        {
          path: 'block-scan-page',
          name: 'block-scan-page',
          meta: {
            title: 'Block Scan',
            needLogin: false
          },
          component: require('@/components/BlockScanPage').default
        },
        {
          path: 'blocks-page',
          name: 'blocks-page',
          meta: {
            title: 'Block Scan',
            needLogin: false
          },
          component: require('@/components/BlocksPage').default
        },
        {
          path: 'transactions-page',
          name: 'transactions-page',
          meta: {
            title: 'Block Scan',
            needLogin: false
          },
          component: require('@/components/TransactionsPage').default
        },
        {
          path: 'block-page',
          name: 'block-page',
          meta: {
            title: 'Block Scan',
            needLogin: false
          },
          component: require('@/components/BlockPage').default
        },
        {
          path: 'transaction-page',
          name: 'transaction-page',
          meta: {
            title: 'Block Scan',
            needLogin: false
          },
          component: require('@/components/transactionPage').default
        },
        {
          path: 'wallets-page',
          name: 'wallets-page',
          meta: {
            title: 'Wallet',
            needLogin: true
          },
          component: require('@/components/WalletsPage').default,
          children: [
            {
              path: ':walletId',
              name: 'wallet',
              meta: {
                title: 'Wallet',
                needLogin: true
              },
              component: require('@/components/Wallet').default
            }
          ]
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!window.sessionStorage.getItem('iroha-wallet:username') && to.meta.needLogin) {
    next({ name: 'login' })
  } else {
    next()
  }
})

// TODO: Add route guards https://router.vuejs.org/en/advanced/navigation-guards.html
export default router
